/**
 * Endpoint composition function 
 * 
 * Author: Andrea López <andrea.lopez@huumun.com>, Sahil David <sahil.david@huumun.com>
 */
import { computed, ref, watchEffect } from 'vue';
import { useRoute, useRouter } from 'vue-router';

import { $lyraEndpoints } from '@/core/modules/lyra/services';
import { getEndpointTierId, isProductSection } from './endpoint.helpers';

export function covidEndpointComposition () {
	const route = useRoute();
	const router = useRouter();

	// Data 
	const endpointData: any = ref<any>({});
	const hasEndpointData = ref<boolean>(false);

	// Computed properties
	const sectionId = computed((): string => route.params.sectionId as string);
	const endpointId = computed((): string => {
		const routeEndpointId = route.params.endpointId as string;
		if (routeEndpointId) {
			return routeEndpointId;
		}

		const metaEndpointId = route.meta.endpointId as string;
		return metaEndpointId;
	});

	// Watcher
	watchEffect(async () => {
		hasEndpointData.value = false;
		endpointData.value = await $lyraEndpoints({
			endpointId: endpointId.value,
			tierId: getEndpointTierId(sectionId.value)
		});
		hasEndpointData.value = (Object.keys(endpointData.value).length > 0);
	});

	// Function to navigate to gallery
	function navigateGallery (): void {
        router.push(`/covid-hub/gallery/${sectionId.value}`);
    }

	return { endpointData, hasEndpointData, navigateGallery }
}

export function productComposition () {
	const route = useRoute();
	const sectionId = computed((): string => route.params.sectionId as string);
	const isProduct = ref<boolean>(isProductSection(sectionId.value));

	return { isProduct }
}